import { useEffect, useState } from 'react';
import s from './DropDownMenu.module.css';
import { useRef } from 'react';
import { createPortal } from 'react-dom';
import IconArrowDown from '../../../shared/ui/icons/IconArrowDown';
import IconArrowUp from '../../../shared/ui/icons/IconArrowUp';
import { Tooltip as ReactTooltip } from 'react-tooltip';
type DropDownOption = {
    value: string;
    label?: string;
    disabled?: boolean;
};

type DropDownMenuProps = {
    options: DropDownOption[];
    selectedOption: string | null;
    setSelectedOption: (option: string) => void;
    placeholder?: string;
    width?: number;
    icon?: JSX.Element;
    iconPosition?: 'left' | 'right';
};
function DropDownMenu({
    options,
    selectedOption,
    setSelectedOption,
    placeholder,
    width,
    icon,
    iconPosition = 'left',
}: DropDownMenuProps) {
    const socialMediaRef = useRef<HTMLDivElement>(null);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const [showSocialMediaDropdown, setShowSocialMediaDropdown] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

    useEffect(() => {
        const handlePointerDown = (e: PointerEvent) => {
            const target = e.target as Node;

            if (
                socialMediaRef.current &&
                !socialMediaRef.current.contains(target) &&
                dropdownRef.current &&
                !dropdownRef.current.contains(target)
            ) {
                setShowSocialMediaDropdown(false);
            }
        };

        document.addEventListener('pointerdown', handlePointerDown);
        return () => document.removeEventListener('pointerdown', handlePointerDown);
    }, []);

    useEffect(() => {
        if (showSocialMediaDropdown && socialMediaRef.current) {
            const rect = socialMediaRef.current.getBoundingClientRect();
            setDropdownPosition({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
            });
        }
    }, [showSocialMediaDropdown]);

    return (
        <div className={s.block} ref={socialMediaRef}>
            <div className={s.selectWrapper}>
                <div
                    className={s.selectBox}
                    style={{ width: width || 400 }}
                    onClick={() => setShowSocialMediaDropdown((prev) => !prev)}
                >
                    {icon && iconPosition === 'left' && icon}
                    {selectedOption ? (
                        <span className={s.selectedSocialMedia}>
                            {selectedOption
                                ?.toLowerCase()
                                .replace(/\b\w/g, (char) => char.toUpperCase())}
                        </span>
                    ) : (
                        <span className={s.placeholder}>{placeholder || 'Select an option'}</span>
                    )}
                    {icon && iconPosition === 'right' && icon}
                </div>
                <button
                    className={s.dropdownToggle}
                    onClick={() => setShowSocialMediaDropdown((prev) => !prev)}
                    aria-label="Toggle social media dropdown"
                >
                    {showSocialMediaDropdown ? <IconArrowUp /> : <IconArrowDown />}
                </button>
            </div>
            {showSocialMediaDropdown &&
                createPortal(
                    <div
                        ref={dropdownRef}
                        className={`${s.dropdown} ${s.dropdownGrid} ${s.floating}`}
                        style={{
                            position: 'absolute',
                            top: dropdownPosition.top,
                            left: dropdownPosition.left,
                            width: `${width || 400}px`,
                            zIndex: 9999,
                            minWidth: `${width || 400}px`,
                            maxWidth: `${width || 400}px`,
                        }}
                    >
                        {options.map((option) => (
                            <div
                                key={option.value}
                                className={`${s.dropdownItem} ${selectedOption === option.value ? s.active : ''} ${option.disabled ? s.disabled : ''}`}
                                onClick={() => {
                                    if (!option.disabled) {
                                        setSelectedOption(option.value);
                                        setShowSocialMediaDropdown(false);
                                    }
                                }}
                            >
                                {option.label
                                    ?.toLowerCase()
                                    .replace(/\b\w/g, (char) => char.toUpperCase()) ||
                                    option.value
                                        .toLowerCase()
                                        .replace(/\b\w/g, (char) => char.toUpperCase())}
                            </div>
                        ))}
                    </div>,
                    document.body,
                )}
        </div>
    );
}

export default DropDownMenu;
